import styled from '@emotion/styled';

import { useTheme } from '@mui/material';

import { capitalize } from 'lodash';

const statusColors = ["success", "info", "warning", "error", 'primary', 'secondary', 'basic'];

const Chip = styled.div`
  background-color: ${props => props.$bgcolor ? props.$bgcolor : "auto"};
  color: ${props => props.$color ? props.$color : "auto"};
  border-radius: ${props => props.$br ? props.$br : "3px"};
  padding: ${props => props.$py ? props.$py : ".4rem"} ${props => props.$px ? props.$px : "1rem"};
  font-weight: 500;
  font-size: ${props => props.$fs ? props.$fs : "1.4rem"};

  @media ${props => props.theme.breaks.down('md')} {
  width: min-content;
 }
`

// values = [{value: "active", label: "Active", status: "success"}, {value: "inactive", status: "error"}] value = "active"

const MultiStatusChip = ({value, values = [], br = '3px', px = '1rem', py = '.4rem', fs = "1.4rem"}) => {
  const findValue = values.find(v => v.value === value);
  const status = findValue?.status;
  const label = findValue?.label;
  const theme = useTheme();
  let bgColor, color, statusText;
  // console.log(status, statusColors.includes(status))
  if (status && statusColors.includes(status)) {
    bgColor = theme.palette[status].light;
    color = theme.palette[status].main;
    statusText = label || value;
  } else {
    bgColor = theme.palette.error.light;
    color = theme.palette.error.main;
    statusText = label || value || "error";
  }

  return <Chip $bgcolor={bgColor} $color={color} $br={br} $px={px} $py={py} $fs={fs}>{capitalize(statusText)}</Chip>
};

export default MultiStatusChip;